export const getUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}') || {}
  } catch (error) {
    return {}
  }
}

export const getFacilityId = () => getUserInfo()?.facility?.id

// Main facility followed by its branches (nested under `facilities`)
export const buildFacilitiesList = (facility) => {
  if (!facility) return []
  const { facilities: branches = [], ...main } = facility
  return [main, ...(branches || [])]
}

// Keeps a flat `facilities` list on userInfo so the navbar can switch between
// the main facility and its branches; `facility` stays the selected one.
export const normalizeUserInfo = (data, fallbackFacility) => {
  if (!data) return data
  let facilities = Array.isArray(data.facilities) && data.facilities.length
    ? data.facilities
    : buildFacilitiesList(data.facility)
  if (facilities.length < 2 && fallbackFacility) {
    facilities = buildFacilitiesList(fallbackFacility)
  }
  return { ...data, facilities }
}

export const getMainFacility = (facilities = []) =>
  facilities.find(item => !item.is_branch) || facilities[0]

// Branch objects can be partial (no facility_type, subscription, ...). The sidebar
// and permissions read those from userInfo.facility, so fill any gaps from the main
// facility, otherwise a branch is treated as an admin account.
export const switchFacility = (facilityId) => {
  const userInfo = getUserInfo()
  const facilities = userInfo.facilities || []
  const selected = facilities.find(item => item.id === facilityId)
  if (!selected) return false
  const main = getMainFacility(facilities)
  const facility = !main || main.id === selected.id
    ? selected
    : Object.entries(selected).reduce((merged, [key, value]) => {
      if (value !== null && value !== undefined && value !== '') merged[key] = value
      return merged
    }, { ...main })
  localStorage.setItem('userInfo', JSON.stringify({ ...userInfo, facility }))
  return true
}

// Stores the result of `default-facility/:id`. The response can be the full user
// (like login) or just the facility; either way the server's data wins over the
// locally merged branch, and the facilities list is kept for the navbar switcher.
export const applyDefaultFacility = (facilityId, data) => {
  if (!switchFacility(facilityId)) return false
  if (!data) return true
  const userInfo = getUserInfo()
  const next = data.facility ? { ...userInfo, ...data } : { ...userInfo }
  const serverFacility = data.facility || (data.id === facilityId ? data : null)
  if (serverFacility) next.facility = { ...userInfo.facility, ...serverFacility }
  if (!Array.isArray(next.facilities) || next.facilities.length < 2) next.facilities = userInfo.facilities
  if (data.token) localStorage.setItem('userToken', data.token)
  localStorage.setItem('userInfo', JSON.stringify(next))
  return true
}
